export default "<app-main-container *ngIf='(login | async)'></app-main-container>\n\n<app-logout *ngIf='!(login | async)'></app-logout>"